
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuYogoroYogoroTopImage } from "@src/constants/images";
import { meta as yogoroMenuPageMeta } from "./yogoro_menu.mdx";
export const meta = {
  path: "/media/harajuku/yogoro",
  title: "【幻のカレー】原宿「ヨゴロウ(YOGORO)」の１日限定５食のカレーに迫る",
  description: "原宿のカレーの名店「ヨゴロウ(YOGORO)」のほうれん草カレーについてまとめました！特に1日限定５食とされる幻のカレー「ポークほうれん草カレー」の詳細と狙い目の時間帯も併せてご紹介させていいただきますので、原宿「ヨゴロウ(YOGORO)」にお越しの際はぜひご確認ください！",
  topImg: harajukuYogoroYogoroTopImage,
  author: murakamiMasanori,
  tags: ["カレー", "有名店", "行列店", "原宿", "人気店", "まとめ記事", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿のカレーの名店「ヨゴロウ(YOGORO)」のほうれん草カレーについてまとめました！`}</p>
    <p>{`原宿・表参道のカレー激戦区の中でトップを走り続けているのが、ほうれん草カレーを提供するヨゴロウ(YOGORO)です。
特に 1 日限定５食とされる幻のカレー「ポークほうれん草カレー」は、見た目のインパクトだけでなく、相性が考えられた食べ物をの選んで作られています。
1 日限定５色のカレーのため、食べられない可能性も高いので、詳細と狙い目の時間帯も併せてご紹介させていいただきます！`}</p>
    <p>{`原宿「ヨゴロウ(YOGORO)」にお越しの際はぜひご確認ください！`}</p>
    <h2>{`原宿・表参道 No.1 のカレー【ヨゴロウ(YOGORO)】`}</h2>
    <p>{`カレー好きなら、知っておかなければならないカレーの名店「ヨゴロウ(YOGORO」。`}</p>
    <p>{`原宿・表参道のカレー人気店である、「mokubaza」「みのりんご」「カリーアップ 」の追随を許さず、カレー激戦区で首位を走っている。
食べログ評価はなんと、`}<strong parentName="p">{`3.81(2020 年 5 月時点)`}</strong>{`で、2019 年には`}<strong parentName="p">{`百名店`}</strong>{`にも選出されており、味も人気も文句なしのカレーの名店！`}</p>
    <h3>{`カフェのようなレトロな店内`}</h3>
    <p>{`ヨゴロウ(YOGORO)の店内は、落ち着いた木目調のテーブルやカウンターがある店内は、レトロでアットホームな雰囲気。`}</p>
    <InstaImage postId="B-J3FweDqRJ" mdxType="InstaImage" />
    <h2>{`ほうれん草カレーが食べられる店`}</h2>
    <h3>{`お店を開くときに他店のカレーを調査せずに創作`}</h3>
    <p>{`ヨゴロウ(YOGORO)のオーナーは、「他店の味に惑わされたくない」という思いがあり、他店の調査をしなかったそうです。驚きですよね。
その試行錯誤の末、`}<strong parentName="p">{`ほうれん草カレー`}</strong>{`を作り上げたと言われています！`}</p>
    <h3>{`ほうれん草カレーが基本ベース`}</h3>
    <h4>{`ほうれん草カレー(1,000 円)`}</h4>
    <InstaImage postId="B73O_LcA9fZ" mdxType="InstaImage" />
    <h4>{`ルーは独特のコクとスパイス`}</h4>
    <p>{`ほうれん草カレーといえば「ドロッとしている」「サラサラ」しているというイメージ。
ヨゴロウ(YOGORO)カレーはそれとは異なり、まろやかで優しいオイリーな食感に、後からキリッとしたスパイスが追いかけてくる。
食べながらいろんな体験ができるカレーになっています。`}</p>
    <h4>{`チキンは注文を受けてから焼き上げる`}</h4>
    <p>{`チキンは作り置きではなく、注文を受けてから、`}<strong parentName="p">{`ニンニク`}</strong>{`で焼き上げる。
できたての香ばしいニンニク香るチキンが、コクのあるカレーとマッチします！`}</p>
    <h4>{`半熟卵をトッピング(+100 円)`}</h4>
    <InstaImage postId="B9EaHUVgbGa" mdxType="InstaImage" />
    <p>{`トッピングできる卵の中身は半熟になっています！
`}<strong parentName="p">{`写真をスライドして三枚目`}</strong>{`に卵を割る動画があります１`}</p>
    <h4>{`サフランライスを無料で大盛りに`}</h4>
    <p>{`黄色に輝くサフランライスは、無料で大盛りにすることができます！
大盛りはなんと`}<strong parentName="p">{`300g`}</strong>{`というボリューム感。
ほうれん草のコクやチキンのスパイスとバッチリ合う！`}</p>
    <h2>{`【限定５食】幻の「ポークほうれん草カレー」(1,350 円)`}</h2>
    <h3>{`ポークほうれん草カレー`}</h3>
    <InstaImage postId="B-HB4RjAl5A" mdxType="InstaImage" />
    <p>{`巨大なボークの肉塊と大根がほうれん草カレーにトッピングされたヨゴロウ(YOGORO)一番の人気カレー。`}</p>
    <h4>{`ジューシーで驚くほど柔らかいポーク`}</h4>
    <InstaImage postId="BHLuRpdAL1R" mdxType="InstaImage" />
    <p>{`断面からジューシーさが伝わってくるポーク。
ポークにスプーンを刺すと、`}<strong parentName="p">{`ストン`}</strong>{`と割れ、口に運ぶと旨味が口の中に広がります。`}</p>
    <h4>{`全て大根が解決してくれる`}</h4>
    <p>{`ジューシーなポーク、コクのあるオイリーなルーという 2 つをホクホクの大根がしっかり吸収してくれ、胃もたれを防ぎます。
サクッと食べるためには、この大根が欠かせない役割を担っています！`}</p>
    <h4>{`限定５色なので中々食べられない`}</h4>
    <p>{`ヨゴロウ(YOGORO)の店外に、この張り紙を見たときは、ポークカレーが食べられません。
狙い目はやはり、開店`}{`*`}{`が 11:30 なので、`}<strong parentName="p">{`11:00`}</strong>{`から並ぶことをオススメします！`}</p>
    <InstaImage postId="B7TBeTEg67d" mdxType="InstaImage" />
    <LinkWithThumbnail meta={yogoroMenuPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`支払い方法`}</h2>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <hr></hr>
    <h2>{`行列状況`}</h2>
    <p>{`ヨゴロウ(YOGORO)では、常に行列が並んでいて、人気に常じてますます多くの人が訪れています。
席数が（カウンター 4 席、テーブル 8 席）と少ないので、行列ができやすくなっています。
できる限り、`}<strong parentName="p">{`なるべく開店前`}</strong>{`に行くことが無難です！`}</p>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`原宿駅から徒歩 10 分
原宿駅を降りて少し歩かないといけないですが、歩いても食べに行きたい…!`}</p>
    <GoogleMap lat={35.6742184} lng={139.708765} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿のカレーの名店「ヨゴロウ(YOGORO)」のほうれん草カレーについてご紹介しました！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;